import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import DocumentList from './components/DocumentList.vue';
import Documents from './components/Documents.vue';
var date = new Date();

var DateSearch = /*#__PURE__*/function (_Vue) {
  _inherits(DateSearch, _Vue);

  var _super = _createSuper(DateSearch);

  function DateSearch() {
    var _this;

    _classCallCheck(this, DateSearch);

    _this = _super.call(this);
    _this.selectYear = date.getFullYear();
    _this.selectMonth = date.getMonth() + 1;
    return _this;
  }

  _createClass(DateSearch, [{
    key: "handleSelectDate",
    value: function handleSelectDate(year, month) {
      this.selectYear = parseInt(year);
      this.selectMonth = month;
    }
  }]);

  return DateSearch;
}(Vue);

DateSearch = __decorate([Component({
  components: {
    DocumentList: DocumentList,
    Documents: Documents
  }
})], DateSearch);
export default DateSearch;